var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.params.data)?_c('div',[_c('h6',{staticClass:"mb-0 font-weight-normal text-center"},[_vm._v(_vm._s(_vm.params.data.company? _vm.params.data.company: '-'))]),_c('p',{staticClass:"text-muted py-0 mt-n2 text-center"},[_c('i',{staticClass:"flaticon2-location text-muted icon-1x pr-2"}),_vm._v(_vm._s(_vm.params.data.location))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }